// client/src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Container, Navbar, Nav, Alert } from 'react-bootstrap';
import Dashboard from './components/Dashboard';
import LabelDesigner from './components/LabelDesigner';
import InventoryManager from './components/InventoryManager';
import PrintQueue from './components/PrintQueue';
import Reports from './components/Reports';
import './App.css';

function App() {
  const [alerts, setAlerts] = useState([]);

  const addAlert = (message, type = 'info') => {
    const id = Date.now();
    setAlerts([...alerts, { id, message, type }]);
    setTimeout(() => {
      setAlerts(alerts.filter(alert => alert.id !== id));
    }, 5000);
  };

  return (
    <Router>
      <div className="App">
        <Navbar bg="dark" variant="dark" expand="lg">
          <Container>
            <Navbar.Brand as={Link} to="/">
              <i className="fas fa-tshirt me-2"></i>
              Dress Label Manager
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link as={Link} to="/">Dashboard</Nav.Link>
                <Nav.Link as={Link} to="/design">Label Designer</Nav.Link>
                <Nav.Link as={Link} to="/inventory">Inventory</Nav.Link>
                <Nav.Link as={Link} to="/print">Print Queue</Nav.Link>
                <Nav.Link as={Link} to="/reports">Reports</Nav.Link>
              </Nav>
              <Nav>
                <Nav.Link href="#">
                  <i className="fas fa-user me-1"></i>
                  Admin
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <Container fluid className="mt-3">
          {/* Alerts */}
          <div className="alert-container">
            {alerts.map(alert => (
              <Alert 
                key={alert.id} 
                variant={alert.type}
                dismissible
                onClose={() => setAlerts(alerts.filter(a => a.id !== alert.id))}
                className="mb-2"
              >
                {alert.message}
              </Alert>
            ))}
          </div>

          <Routes>
            <Route path="/" element={<Dashboard addAlert={addAlert} />} />
            <Route path="/design" element={<LabelDesigner addAlert={addAlert} />} />
            <Route path="/inventory" element={<InventoryManager addAlert={addAlert} />} />
            <Route path="/print" element={<PrintQueue addAlert={addAlert} />} />
            <Route path="/reports" element={<Reports addAlert={addAlert} />} />
          </Routes>
        </Container>

        <footer className="bg-dark text-white text-center py-3 mt-4">
          <Container>
            <p className="mb-0">
              TVS LP46 Dress Label Manager &copy; {new Date().getFullYear()} | 
              Designed for 50mm × 80mm dress label sticker rolls
            </p>
          </Container>
        </footer>
      </div>
    </Router>
  );
}

export default App;